import { IApplicationState } from '../../../../../../../types/types';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getIsUserEssentialPlanOnly } from '../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';

export const checkExportTabAllow = (
    state: IApplicationState,
): boolean => {
    if (getIsUserEssentialPlanOnly(state)) {
        const { allowGoogleSheetExport } = getAuthUser(state);
        return allowGoogleSheetExport;
    }
    return true;
}
